import AccordionComponent from "./components/Accordion"
import InformationBlocks from "./components/InformationBox"

export default function InfoTab({ data }: { data: any }) {
  return (
    <>
      <AccordionComponent data={data} initialClosed={true} />
      <InformationBlocks data={data} />
    </>
  )
}
